module.exports = __webpack_public_path__ + "340a244dec8bf737016a7e5829c7840e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/1.jpg
// module id = 289
// module chunks = 0